import moment from "moment";
import { keyBy } from "lodash";
import { createCrudActions } from '../utils/crudGenerator';
import { axios } from "../connection/ConnectionHandler";

const formatSalesShipments = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item.No,
        posting_date: item.posting_date && moment(item.posting_date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};


export const getSalesShipmentPDF = (shippingNo) => {
    return axios.post('/shipments/download-pdf', { shippingNo })
}

export const sendUnsignedSalesShipmentsReportEmail = () => {
    return axios.post('/salesShipment/send-unsigned-report');
}

export const signSalesShipments = (payload) => async (dispatch) => {
    try {
        const response = await axios.post('/salesShipment/sign', payload);
        const signedShipments = formatSalesShipments(response.data?.shipments || []);
        signedShipments.forEach((shipment) => {
            dispatch({
                type: 'UPDATE_SALESSHIPMENT',
                payload: shipment,
            });
        });
        return response;
    } catch (err) {
        return err?.response || err;
    }
}

export const {
    fetch: fetchSalesShipments,
    create: createSalesShipment,
    update: updateSalesShipment,
    delete: deleteSalesShipments
} = createCrudActions('SALESSHIPMENT', "Reparto", formatSalesShipments);

// Acción específica para obtener datos de Business Central
export const fetchSalesShipmentsFromBC = (params) => async (dispatch) => {
    try {
        const response = await axios.get('/salesShipment', { params });
        if (response.status >= 200 && response.status < 300) {
            const formattedData = formatSalesShipments(response.data);
            dispatch({
                type: 'SET_SALESSHIPMENT_LIST',
                payload: keyBy(formattedData, "value"),
            });
        }
        return response.status;
    } catch (err) {
        console.error(err);
        return err;
    }
};
